import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Gallery from '@/images/Gallery.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Button, CircularProgress } from '@mui/material';

export interface BackgroundButtonProps {
    isProcessing: boolean;
    disabled: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
}

const StyledBackgroundsButton = styled(Button)`
    z-index: 1;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 0.5px solid ${theme.colors.secondary[100]};
    background: ${theme.colors.white};

    :focus {
        outline: none;
    }

    :hover {
        background-color: ${({ theme }) => theme.colors.black[200]} !important;
    }
`;

const ButtonWrapper = styled.div`
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0px;
        right: 8px;
        height: 16px;
        width: 32px;
        z-index: 1;
        pointer-events: auto;
        opacity: 0;
    }
`;

const BackgroundButton = ({ onClick, isProcessing, disabled, ...props }: BackgroundButtonProps) => (
    <ButtonWrapper>
        <StyledBackgroundsButton onClick={onClick} disabled={disabled} {...props}>
            {isProcessing ? <CircularProgress size={16} /> : <MaskedIcon src={Gallery} color={theme.colors.black.main} size="16px" />}
        </StyledBackgroundsButton>
    </ButtonWrapper>
);

export default BackgroundButton;
